import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import {
  IUnit,
  IUnitData,
} from 'src/app/modules/unit/interfaces/unit.interface';
import { EnvService } from 'src/app/services/env.service';

@Injectable({
  providedIn: 'root',
})
export class UnitsService {
  readonly unitUrl = `${this.env.URL_API_V1}/unit`;
  readonly caseTypeUrl = `${this.env.URL_API_V1}/casetype`;
  constructor(private readonly http: HttpClient, private env: EnvService) {}

  getAll() {
    return this.http.get<IUnit[]>(`${this.unitUrl}/getAll`);
  }

  getTypeCases(unit) {
    return this.http.get<ICaseType[]>(`${this.caseTypeUrl}/unit/${unit}`);
  }

  getById(id) {
    return this.http.get<IUnit>(`${this.unitUrl}/get/${id}`);
  }

  getAllData(user) {
    return this.http.post<IUnitData[]>(`${this.unitUrl}/allData`, user);
  }
  allDataFilters() {
    return this.http.get<IUnitData[]>(`${this.unitUrl}/allDataFilters`);
  }

  getUnitAndCaseType(units) {
    return this.http.put<IUnit[]>(`${this.unitUrl}/unitCaseType`, { units });
  }
}
